import { useEffect, useState } from "react";
import { ArrowLeft, Loader2 } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { ResultBars } from "@/components/tss/ResultBars";
import { AlpanaDivider } from "@/components/tss/Ornaments";
import { SiteFooter } from "@/components/tss/SiteFooter";

export default function LeaderboardPage() {
  const [data, setData] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    const load = () => api.get("/public/leaderboard").then((r) => { setData(r.data); setError(""); }).catch((e) => setError(errMsg(e)));
    load();
    const t = setInterval(load, 15000);
    return () => clearInterval(t);
  }, []);

  return (
    <main className="alpana-bg min-h-screen pb-10" data-testid="leaderboard-page">
      <header className="grain bg-maroon px-4 pb-8 pt-6 text-ivory">
        <div className="mx-auto max-w-2xl">
          <a href="/" data-testid="leaderboard-back-link" className="inline-flex items-center gap-1 text-sm text-gold-light"><ArrowLeft className="h-4 w-4" /> Back to voting</a>
          <h1 className="mt-4 font-display text-4xl font-bold">Leaderboard</h1>
          <p className="font-bengali text-lg text-ivory/85">জনতার পছন্দ · ফলাফল</p>
          <AlpanaDivider className="mt-5" />
        </div>
      </header>
      <div className="mx-auto max-w-2xl space-y-4 px-4 py-6">
        {error && <p data-testid="leaderboard-hidden" className="rounded-2xl border border-gold bg-white p-6 text-center text-ink">{error}</p>}
        {!data && !error && <Loader2 className="mx-auto h-6 w-6 animate-spin text-maroon" />}
        {data?.map((c) => <ResultBars key={c.id} category={c} limit={5} />)}
      </div>
      <SiteFooter />
    </main>
  );
}
